import { useEffect } from 'react'
import { useUiStore } from '../../stores/uiStore'

export function MediaViewer() {
  const { mediaViewerUrl, closeMedia } = useUiStore()

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') closeMedia() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [closeMedia])

  if (!mediaViewerUrl) return null

  const isVideo = /\.(mp4|webm|ogg)(\?|$)/i.test(mediaViewerUrl)

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center animate-fade-in"
      onClick={closeMedia}
    >
      <button
        className="absolute top-4 right-4 text-white text-3xl leading-none hover:text-gray-300"
        onClick={closeMedia}
        aria-label="Close"
      >
        ✕
      </button>
      <div onClick={(e) => e.stopPropagation()} className="max-w-[90vw] max-h-[90vh]">
        {isVideo ? (
          <video src={mediaViewerUrl} controls autoPlay className="max-w-full max-h-[90vh] rounded" />
        ) : (
          <img src={mediaViewerUrl} alt="media" className="max-w-full max-h-[90vh] object-contain rounded" />
        )}
      </div>
    </div>
  )
}
